import { render, staticRenderFns } from "./ReservationStatuses.vue?vue&type=template&id=039ef9ac&scoped=true&"
import script from "./ReservationStatuses.vue?vue&type=script&lang=js&"
export * from "./ReservationStatuses.vue?vue&type=script&lang=js&"
import style0 from "./ReservationStatuses.vue?vue&type=style&index=0&id=039ef9ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039ef9ac",
  null
  
)

export default component.exports